<script>
import AppActionButton from '@/components/AppActionButton'
import UploadResumable from '@/components(new)/UI/Forms/DocumentUpload/UploadResumable/UploadResumable.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import utils from '@/utils/utils'
import VisualizarDocumentos from '@/components(new)/UI/Modals/VisualizarDocumentos/VisualizarDocumentos.vue'
import FileSaver from 'file-saver'
import { mapActions } from 'vuex'

export default {
  components: {
    AppActionButton,
    UploadResumable,
    Label,
    VisualizarDocumentos
  },

  data () {
    return {
      documentView: null,
      modalDocumentViewIsOpen: false
    }
  },

  props: {
    id: {
      type: String,
      required: true
    },
    files: {
      type: Array,
      required: true
    },
    fileTypes: {
      type: Array,
      default: () => ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'zip']
    },
    enabledDocumentViewTypes: {
      type: Array,
      default: () => ['jpeg', 'png', 'jpg', 'pdf']
    },
    showDocumentView: {
      type: Boolean,
      default: true
    },
    showDownload: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: true
    },
    maxSize: {
      type: Number,
      required: false
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    listLabel: {
      type: String,
      default: 'Anexos'
    }
  },

  computed: {
    ruleRequired () {
      return this.isRequired && !this.files.length
    }
  },

  methods: {
    ...mapActions({
      getDocumentoViewByKey: 'documento/getDocumentoViewByKey',
      getDocumentoViewByPath: 'documento/getDocumentoViewByPath',
      downloadDocumentoById: 'documentos/downloadDocumentoById',
      downloadDocumentoByKey: 'documentos/downloadDocumentoByKey'
    }),
    async getDownload (document) {
      const doc = await (document.id ? this.downloadDocumentoById(document.id) : this.downloadDocumentoByKey(document.key))
      FileSaver.saveAs(doc, document.fileName)
    },
    removeFile (document) {
      if (!document.status) {
        this.$emit('removeFile', document)
      }
    },
    documentHasView (row) {
      let extension = utils.getExtensionFile(row.nome)
      return this.enabledDocumentViewTypes.includes(extension)
    },
    async viewDocument (document) {
      this.documentView = await (document.caminho ? this.getDocumentoViewByPath(document.caminho) : this.getDocumentoViewByKey(document.key))
      this.modalDocumentViewIsOpen = true
    },
    closeDocumentViewModal () {
      this.documentView = null
      this.modalDocumentViewIsOpen = false
    },
    uploadFile (file) {
      this.$emit('uploadFile', file)
    }
  }
}
</script>

<template>
  <div>
     <visualizar-documentos
      v-if="modalDocumentViewIsOpen"
      @closeModal="closeDocumentViewModal"
      :documentos="[documentView]"
    />
    <div class="mt-20px">
      <div class="padding-right-30px">
        <upload-resumable
          :id="id"
          :fileTypes="fileTypes"
          :required="ruleRequired"
          @uploadFile="uploadFile"
        />
      </div>
      <div v-if="files.length" class="mt-20px">
        <Label v-if="listLabel" :label="listLabel" :obrigatorio="isRequired" />
        <el-table :data="files">
          <el-table-column label="Nome do Arquivo:" prop="nome"/>
          <el-table-column width="120">
            <template slot-scope="scope">
              <div class="flex-center">
                <app-action-button
                  v-if="showDocumentView"
                  icone="eye"
                  :cor="!documentHasView(scope.row) ? '#C0C4CC' : '#666666'"
                  :text="!documentHasView(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar Documento' "
                  @click="viewDocument(scope.row)"
                  :disabled="!documentHasView(scope.row)"
                />
                <app-action-button
                  v-if="showDownload"
                  icone="download"
                  @click="getDownload(scope.row)"
                  cor="#666666"
                  text="Baixar Documento"
                />
                <app-action-button
                  v-if="showDelete"
                  icone="trash"
                  @click="removeFile(scope.row)"
                  cor="#666666"
                  text="Remover Documento"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/DocumentUpload/DocumentUpload.vue